module.exports = __webpack_public_path__ + "static/img/index1.04f4d4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index1.png
// module id = G+bM
// module chunks = 7